import { combineReducers } from 'redux';
import conditionalSplitReducer from './conditionalSplit';
import emailSeries from './emailSeries';
import singleSend from './singleSend';

const curationReducer = combineReducers({
    conditionalSplit: conditionalSplitReducer,
    singleSend: singleSend,
    emailSeries: emailSeries,
});

export default curationReducer;
